import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { MediaQuery } from '@grandvisionhq/common';
import SkipToMapLinkContainer from '../SkipToMapLink/SkipToMapLinkContainer.js';
import LocationSearchList from '../LocationSearchList/LocationSearchList.js';

const LocationSearchListLayout = (_param)=>{
    var { className , loadingListItems , listItems , topContent , searchForm , showTabs , infoContent , showLinkToMap , googleMapsId , highlightPreferredStore  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "loadingListItems",
        "listItems",
        "topContent",
        "searchForm",
        "showTabs",
        "infoContent",
        "showLinkToMap",
        "googleMapsId",
        "highlightPreferredStore"
    ]);
    const isMobile = MediaQuery.useIsPhone();
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('location-search-list-layout', className)
    }), topContent, /*#__PURE__*/ React.createElement("div", {
        className: classnames('location-search-list-layout__search-form')
    }, !isMobile ? searchForm : null, showLinkToMap && googleMapsId && /*#__PURE__*/ React.createElement(SkipToMapLinkContainer, {
        mapId: googleMapsId
    })), highlightPreferredStore, infoContent, /*#__PURE__*/ React.createElement(LocationSearchList, {
        loading: loadingListItems
    }, listItems));
};

export { LocationSearchListLayout as default };
//# sourceMappingURL=LocationSearchListLayout.js.map
